import { css, jsx } from '@emotion/core';
import { Input } from 'antd';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import Form from '@/src/shared/components/Form';
import { bp, colors } from '@/styles';

const styles = {
  inputContainer: css`
    width: 100%;
    margin: 1.6rem 0;
    @media ${bp.md} {
      max-width: 36.5rem;
    }
    .ant-input {
      border-width: 1px;
      border-style: solid;
      border-color: rgb(218, 217, 215);
    }
  `,
};

const TextInput = ({ form, info, step, currentInfo, key, onChange }) => {
  const [isEmailValid, setEmailValid] = useState(false);

  const { register } = useSelector(state => state);

  const handleConfirmBlur = e => {
    const {
      target: { value },
    } = e;
    setEmailValid(isEmailValid || !!value);
  };

  const validateFirstEmail = (rule, value, callback) => {
    if (value && value !== form.getFieldValue('EmailAddress')) {
      callback('Enter the same email.');
    } else {
      callback();
    }
  };

  const validateConfirmEmail = (rule, value, callback) => {
    if (value && isEmailValid) {
      form.validateFields(['ConfirmEmailAddress'], { force: true });
    }
    callback();
  };

  return (
    <>
      <div key={key} css={styles.inputContainer}>
        <Form.Item label="Email" hasFeedback>
          {form.getFieldDecorator('EmailAddress', {
            initialValue: register['EmailAddress'],
            rules: [
              {
                required: true,
                message: 'Enter email.',
              },
              {
                validator: validateConfirmEmail,
              },
              {
                required: true,
                message: 'Please confirm your email.',
              },
              {
                type: 'email',
                message: 'Enter valid email.',
              },
            ],
          })(
            <Input
              onChange={e => {
                onChange('EmailAddress', e);
              }}
              onPaste={e => {
                e.preventDefault();
                return false;
              }}
              size="large"
            />
          )}
        </Form.Item>
      </div>
      <div key={key} css={styles.inputContainer}>
        <Form.Item label="Confirm Email" hasFeedback>
          {form.getFieldDecorator('ConfirmEmailAddress', {
            initialValue: register['ConfirmEmailAddress'],
            rules: [
              {
                required: true,
                message: 'Please confirm your email.',
              },
              {
                type: 'email',
                message: 'Enter valid email.',
              },
              {
                validator: validateFirstEmail,
              },
            ],
          })(
            <Input
              onChange={e => {
                onChange('ConfirmEmailAddress', e);
              }}
              onPaste={e => {
                e.preventDefault();
                return false;
              }}
              size="large"
              onBlur={handleConfirmBlur}
            />
          )}
        </Form.Item>
      </div>
    </>
  );
};

TextInput.defaultProps = {
  formOverrides: {},
  onChange: () => {},
};
export default TextInput;
